import SectionCard from "@/components/SectionCard";
import LeyendaEstado from "@/components/pipeline/LeyendaEstado";
import { formatNum } from "@/lib/constants";

export default function PanelDetalle({ subEtapas, applyFilters }) {
  return (
    <SectionCard
      title="Detalle de etapa"
      subtitle="Sub-etapas y tasas de conversión"
      testid="panel-detalle"
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-slate-500 border-b border-slate-200">
              <th className="text-left py-2 font-medium">Sub-etapa</th>
              <th className="text-right py-2 font-medium">Pacientes</th>
              <th className="text-right py-2 font-medium">Conversión</th>
              <th className="text-center py-2 font-medium">Estado</th>
            </tr>
          </thead>
          <tbody>
            {subEtapas.map((sub, i) => (
              <tr key={i} className="border-b border-slate-100 last:border-0">
                <td className="py-2.5 font-medium text-slate-900">{sub.nombre}</td>
                <td className="py-2.5 text-right tabular-nums text-slate-700">
                  {sub.pacientes != null ? formatNum(applyFilters(sub.pacientes)) : "—"}
                </td>
                <td className="py-2.5 text-right tabular-nums text-slate-700">
                  {sub.conversion != null ? `${sub.conversion}%` : "—"}
                </td>
                <td className="py-2.5 text-center">
                  <LeyendaEstado estado={sub.estado} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SectionCard>
  );
}
